import script from "./ImageGalleryModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageGalleryModal.vue?vue&type=script&setup=true&lang=ts"

import "./ImageGalleryModal.vue?vue&type=style&index=0&id=26b19fba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b19fba"]])

export default __exports__